import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {AudioService} from '../../../services/audio/audio.service';
import {GraphemeService} from '../../../services/grapheme/grapheme.service';
import {CommonModule} from '@angular/common';
import {GraphemeItemComponent} from '../../../components/learning/grapheme-item/grapheme-item.component';
import {TranslateModule} from '@ngx-translate/core';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-games-levels-graphemes',
  standalone: true,
  imports: [
    CommonModule,
    GraphemeItemComponent,
    TranslateModule,
    SpinnerComponent
  ],
  templateUrl: './games-levels-graphemes.component.html',
  styleUrls: ['./games-levels-graphemes.component.scss']
})
export class GamesLevelsGraphemesComponent implements OnInit {

  @Input() level: any;

  type  = 'hiragana';
  loader = true;
  graphemes: any = [];

  constructor(
    private activeModal: NgbActiveModal,
    public langSrcSrv: LangSrcService,
    public langTgtSrv: LangTgtService,
    public audioSrv: AudioService,
    public graphemeSrv: GraphemeService
  ) {
  }

  async ngOnInit() {
    try {
      this.graphemes = await this.graphemeSrv.getLetters();
    } catch {
      this.graphemes = [];
    } finally {
      this.loader = false;
    }
  }

  trackById(index: number, item: any) { return item.id; }

  close() {
    this.activeModal.close();
  }

  changeType(type: string): void {
    this.type = type;
  }
}
